import {SlideChart} from '../slide-chart/SlideChart';
import {OscilloRenderer} from './OscilloRenderer';
import {OscilloRenderContext} from './OscilloRenderContext';

	export class OscilloChart extends SlideChart {

		public context: OscilloRenderContext;
		public renderer: OscilloRenderer;

		public constructor(element: string | Element | JQuery) {
			super(element);
		}

		protected createRenderContext(container: string | Element | JQuery) {
			return new OscilloRenderContext(container);
		}

		protected createRenderer() {
			return new OscilloRenderer();
		}

		protected update = () => {
			setTimeout(() => {
				if(this.isRunning) {
					var timeline = this.context.axesConfiguration.xAxes[0];
					var now = this.getNow();
					if(now >= timeline.maximum) {
						this.setStartTime(now);
					}
					this.context.clearPosition = now;
					this.context.historyStart = now - (timeline.maximum - timeline.minimum);
					this.redraw();
					this.animationFrame = requestAnimationFrame(this.update);
				}
			}, 1000 / this.fps);
		}

		protected shortenData() {
			this.context.seriesConfiguration.series.forEach(series => {
				while(series.values.length > 0) {
					var item = series.values.shift();
					var time = series.valueProvider.getX(item);
					if (time >= this.context.historyStart) {
						series.values.unshift(item);
						break;
					}
				}
			});
		}

	}

